module.exports = __webpack_public_path__ + "media/brands/lmc-dd59ef63.png";